import React from "react";

function VSCode() {
	return (
		<div className="height-100">
			<iframe
				src="https://github.com/Chirag26mahajan/Portfolio_OS_Theme/blob/master/src/App.js"
				frameBorder="0"
				height="100%"
				width="100%"
				title="VSCode"
			></iframe>
		</div>
	);
}

export default VSCode;
